import type { AppRoute } from "../lib/routes";
import "./RouteLoading.css";

type RouteLoadingProps = {
  label: string;
  route: AppRoute;
};

export function RouteLoading({ label, route }: RouteLoadingProps) {
  const loadingRoute =
    route === "category"
      ? "catalog"
      : route === "payment" || route === "order"
        ? "orders"
        : route;

  return (
    <section
      className={`route-loading route-loading--${loadingRoute}`}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <span className="sr-only">{label}</span>

      {loadingRoute === "product" ? (
        <>
          <span className="route-loading__media" aria-hidden="true" />
          <span className="route-loading__body" aria-hidden="true">
            <span className="route-loading__line route-loading__line--short" />
            <span className="route-loading__line route-loading__line--title" />
            <span className="route-loading__line route-loading__line--mid" />
            <span className="route-loading__button" />
          </span>
        </>
      ) : null}

      {loadingRoute === "cart" ? (
        <span className="route-loading__cart" aria-hidden="true">
          <span className="route-loading__items">
            {Array.from({ length: 2 }, (_, index) => (
              <span className="route-loading__item-card" key={index} />
            ))}
          </span>
          <span className="route-loading__summary-card" />
        </span>
      ) : null}

      {loadingRoute === "orders" ? (
        <span className="route-loading__orders" aria-hidden="true">
          {Array.from({ length: 3 }, (_, index) => (
            <span className="route-loading__order-card" key={index} />
          ))}
        </span>
      ) : null}

      {loadingRoute === "catalog" ? (
        <span className="route-loading__grid" aria-hidden="true">
          {Array.from({ length: 4 }, (_, index) => (
            <span className="route-loading__card" key={index}>
              <span className="route-loading__media" />
              <span className="route-loading__caption" />
            </span>
          ))}
        </span>
      ) : null}
    </section>
  );
}
